"use strict";

function dynamicRouterProvider($stateProvider, util) {
	this.$get = function () {
		return new DynamicRouter(stacks, util);
	};

	var stacks = {};

	function registerCommonRoutes(conf, route, routeName) {
		if( conf.pages[routeName]) {
			var routeConfig = angular.extend({}, conf.pages[routeName], route.config);
			routeConfig.views = {
				'@': {
					title: routeConfig.title,
					templateUrl: routeConfig.templateUrl,
					controller  : routeConfig.controller,
					controllerAs : routeConfig.controllerAs
				},
				'header@': {
					template: routeConfig.title
				}
			};
			$stateProvider.state(routeName, routeConfig);
		}
	}

	function registerStepsRoutes(conf, stack, stackName) {
		var allRoutes = stack.steps.slice();
		allRoutes.push(stack.home);

		for (var key in allRoutes) {
			var route = allRoutes[key];
			var page = conf.pages[route.name];
			var stepNum = parseInt(key) + 1;
			
			if (!(page || route.config.abstract ))
				throw 'Qbe Portal : Expected state URL for state ' + route.name + ' but could not find it';

			if (page) {
				route.config.url = page.url;
				route.config.views['@'].title = page.title;
				route.config.views['@'].templateUrl = page.templateUrl;
				route.config.views['sidebar@'].templateUrl = page.sidebarTemplateUrl;
				// start add updates
		        //route.config.views['progressbar@'].templateUrl = page.progressbarTemplateUrl;
		        //route.config.views['headbar@'].templateUrl = page.headbarTemplateUrl;
		        // end
				route.config.views['meta@'].templateUrl = page.metaTemplateUrl;
				route.config.views['header@'].template = page.title;
				route.config.progressBarTitle = page.progressBarTitle;
				route.config.progressBarShortTitle = 'Step ' + stepNum + ' - ' + page.progressBarShortTitle;
				route.config.stateName = route.name;

				if(page.params) {
					route.config.params = page.params;
				}
			}

			$stateProvider.state(route.name, route.config);
		}
		stacks[stackName] = stack;
	}

	this.init = function (conf, stacks) {
		for (var routeName in routes.common) {
			var route = routes.common[routeName],
				routeConfig;

			if (!route) {
				throw 'Qbe Portal : Expected routing stack with name ' + routeName + ' but could not find it';
			}

			registerCommonRoutes(conf, route, routeName) ;
		}

		for (var key in stacks) {
			var stackName = stacks[key];
			var stack = routes[stackName];
			if (!stack)
				throw 'Qbe Portal : Expected routing stack with name ' + stackName + ' but could not find it';

			registerStepsRoutes(conf, stack, stackName) ;
		}
	};
}

function DynamicRouter(stacks, util) {
	var currentStack,
		currentState,
		currentStep,
		totalSteps,
		steps,
		conditions,
		lastCompletedStep;


	window.addEventListener('route-changed', function (e) {
		lastCompletedStep = typeof(e.detail.completed) === 'string' ? e.detail.completed : null;
	}, false);


	/**
	 * Initialises the dynamic router.
	 * @stateName:  state name of current page e.g. 'vehicle.drivers'
	 * @stackname: name of the parent of current page e.e. 'vehicle'
	 * @stepConditions: optional - a conditions object which may includes conditions for certain states determining if they are visible.
	 */
	function initialise(stateName, stackName, stepConditions, markCompletedFn) {
		if (stackName == "") stackName = stateName; // state is parent state.
		conditions = stepConditions || {} ;
		currentStack = stacks[stackName];
		clearSteps() ;
		steps = getSteps() ;
		var currentStepDef = findStepByName(steps, stateName) ;
		currentState = currentStepDef.name;
		currentStep = currentStepDef.index;
		totalSteps = steps.length;
		checkRouteAllowed(markCompletedFn);
	}

	function checkRouteAllowed(markCompletedFn) {
		/** first route step is always allowed */
		var step = findStepByName(steps, lastCompletedStep);

		if ( currentState.indexOf('.done') !== -1 )
			return true;

		if (!step && lastCompletedStep) {
			dispatchCustomEvent('cross-route-disallowed');
			return false;
		}

		if(currentState == 'home.property'){
			//special condition to allow the home retrieve
			return true;
		}

		if(currentState == 'bike.quote'){
			//special condition to allow the home retrieve
			return true;
		}

		if(currentState == 'caravan.quote'){
			//special condition to allow the home retrieve
			return true;
		}

		if (currentStep > 0) {
			if ( ! step || currentStep > step.index + 1 ){
				dispatchCustomEvent('route-disallowed',
					{
					redirect: lastCompletedStep,
					msg :'Not allowed to navigate to route ' + currentStep
					}
				);
				return false;
			}
		}

		/**
		 * updates the completed route only when backtracking
		 * to previous steps.  For going next update completed
		 * needs to be updated by the next() function.
		 */
		if (step && currentStep < step.index)
			markCompletedFn(currentState) ;

		return true;
	}

	function findStepByName(steps, stateName) {
		var selectedStep = null ;
		steps.some(
			function (step, i) {
				if (step.stateName == stateName) {
					selectedStep = {
						name : stateName,
						index : i,
					};
					return true;
				}
			}
		);
		return selectedStep ;
	}

	function getPageTitle() {
		return steps[currentStep].progressBarTitle;
	}

	function getSteps() {
		if ( currentStack && currentStack.steps ) {
			if ( !steps) {
				steps = currentStack.steps.map(
					function (step, i) {
						var addStep = !conditions[step.config.stateName] || conditions[step.config.stateName]() ;
						if ( addStep )
							return {
								title: step.config.title,
								progressBarTitle: step.config.progressBarTitle,
								progressBarShortTitle: step.config.progressBarShortTitle,
								stepNumber: i,
								stateName : step.config.stateName
							}
					}
				);

				steps = steps.filter(function(step){ return !!step}) ;
			}
		}
		return steps;
	}

	function clearSteps() {
		steps = null ;
	}

	function next(markCompletedFn) {
		markCompletedFn(getCurrentState().name);
		return steps[++currentStep].stateName;
	}

	function getNextState() {
		return steps[currentStep+1].stateName;
	}


	function getCurrentState() {
		return {
			name: steps[currentStep].stateName,
			number: currentStep
		}
	}

	function back() {
		if ( currentStep > 0)
			return steps[--currentStep].stateName;

		return false;
	}

	function getState(step) {
		return steps[step].stateName;
	}

	return {
		initialise: initialise,
		next: next,
		back: back,
		getPageTitle: getPageTitle,
		getSteps: getSteps,
		getState: getState,
		getCurrentState: getCurrentState,
		getNextState: getNextState,
	};
}
